module.exports = __webpack_public_path__ + "img/3.f20b4c7167.jpg";